import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { EmBlueHero } from '@/components/Elements/EmBlueHero';
import { Head } from '@/components/Head';
import { PublicLayout } from '@/components/Layout';
import { ProductsPage } from '@/features/misc';
import { useGeoLocation } from '@/hooks/useGeoLocation';
const IframeEmblueWrap = styled.div`
  .payments_iframe_emblue {
    width: 100%;
    height: 210vh;
    border: none;
    overflow: hidden;
  }

  .payments_iframe_emblue:focus-visible {
    outline: none;
  }
`;

const IframePricingEmblueWrap = styled.div`
  .payments_iframe_pricing_emblue {
    width: 100%;
    height: 700vh;
    border: none;
  }

  .payments_iframe_pricing_emblue:focus-visible {
    outline: none;
  }
`;

export const Products = () => {
  const { isSet, isEurope } = useGeoLocation();
  const { t } = useTranslation();

  return (
    <PublicLayout className="flex">
      <Head page="Product" />
      {isSet && isEurope() && <ProductsPage />}
      {isSet && !isEurope() && <EmBlueHero className="mb-14 lg:mb-4" />}
      {isSet && !isEurope() && (
        <IframeEmblueWrap>
          <div className="flex justify-center w-full">
            <iframe
              scrolling="no"
              className="payments_iframe_emblue"
              id="inlineFrameEmblue"
              title="Inline Frame Emblue"
              src={t('ProductsPublicPage.iframeEmblue')}
            ></iframe>
          </div>
        </IframeEmblueWrap>
      )}
      {isSet && !isEurope() && (
        <IframePricingEmblueWrap>
          <div className="flex justify-center w-full">
            <iframe
              className="payments_iframe_pricing_emblue"
              id="inlineFramePricingEmblue"
              title="Inline Frame Emblue"
              src={t('ProductsPublicPage.iframePricingEmblue')}
            ></iframe>
          </div>
        </IframePricingEmblueWrap>
      )}
    </PublicLayout>
  );
};
